import { createCRUDHook } from './createCRUDHook';
import { BunCalcQtyDto } from 'utils/models';
import { TLKP_BUN_MATRIX } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<BunCalcQtyDto>({
  entityName: 'BunCalcQty',
  endpoint: TLKP_BUN_MATRIX,
});

export const BunCalcQtyContext = Context;
export const useBunCalcQtyManager = useManager;
export const useBunCalcQty = useConsumer;
